'use client';
// Public storefront header — hidden on /admin/* (admin has its own chrome).
import { usePathname } from 'next/navigation';
import { Header } from './Header';

export function ConditionalHeader() {
  const pathname = usePathname();
  if (pathname?.startsWith('/admin')) return null;
  if (pathname?.startsWith('/labs')) return null; // style prototypes render their own chrome
  if (pathname?.startsWith('/delivery')) return null; // персональна видача — самостійна сторінка без сайтового chrome
  return <Header />;
}
